'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fadeOut = require('./fade-out');

var _fadeOut2 = _interopRequireDefault(_fadeOut);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MultiSelect = _react2['default'].createClass({
  displayName: 'MultiSelect',


  propTypes: {
    initiallySelectedOptionValues: _react2['default'].PropTypes.array.isRequired,
    onSelectionChange: _react2['default'].PropTypes.func.isRequired,
    disabled: _react2['default'].PropTypes.bool,
    options: function options(props, propName, componentName) {
      if (props[propName] === undefined || !$.isArray(props[propName])) {
        throw new Error(propName + ' must be an array for ' + componentName);
      }
      props[propName].forEach(function (entry) {
        if (entry.key === undefined) {
          throw new Error('key attribute must exist for each entry of ' + propName + ' for ' + componentName);
        }
        if (entry.descr === undefined) {
          throw new Error('descr attribute must exist for each entry of ' + propName + ' for ' + componentName);
        }
      });
    },
    statusMessage: function statusMessage(props, propName, componentName) {
      if (props[propName] !== null) {
        if (props[propName].className === undefined) {
          throw new Error(propName + '.className must be defined for ' + componentName);
        }
        if (props[propName].text === undefined) {
          throw new Error(propName + '.text must be defined for ' + componentName);
        }
      }
    }
  },

  // Just a band-aid to prevent react from making the multi-select from disappearing. Fix
  // is to refactor this component to be entirely reactified. (CC)
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return !this.preventRerender;
  },

  getInitialState: function getInitialState() {
    return {
      selectedOptionValues: this.props.initiallySelectedOptionValues
    };
  },

  componentDidMount: function componentDidMount() {
    this._setupMultiSelect();
  },

  componentDidUpdate: function componentDidUpdate() {
    this._setupMultiSelect();
  },

  _setupMultiSelect: function _setupMultiSelect() {
    var self = this;
    var selectEl = $('select', _reactDom2['default'].findDOMNode(this));

    selectEl.multiselect('destroy');

    selectEl.multiselect({
      selectEl: this,
      minWidth: 300,
      maxHeight: 300,
      noneSelectedText: 'Please select one',
      open: function open() {
        self.preventRerender = true;
      },
      selectedText: function selectedText(num, total, checkedEls) {
        if (num > 2) {
          return checkedEls[0].title + ' and ' + (num - 1) + ' more';
        } else if (num == 2) {
          return checkedEls[0].title + ' and ' + checkedEls[1].title;
        } else if (num == 1) {
          return checkedEls[0].title;
        }
      },
      close: function close() {

        self.preventRerender = false;

        if (self.props.disabled) {
          return;
        }
        // FIXME: onChange and .selectedOptions both don't work when we use jQuery multiselect plugin, so we have to go this less React-y route of fetching data from the DOM using jQuery
        var checkedEls = selectEl.multiselect('getChecked');
        var checkedValues = checkedEls.map(function () {
          return this.value;
        }).get();

        self.props.onSelectionChange(checkedValues);
        self.setState({ selectedOptionValues: checkedValues });
      }
    });

    if (this.props.disabled) {
      selectEl.multiselect('disable');
    }
  },

  render: function render() {
    var selectionOptions = this.props.options.map(function (option) {
      return _jsx('option', {
        value: option.key
      }, option.key, option.descr);
    }, this);

    var msg = this.props.statusMessage ? _jsx(_fadeOut2['default'], {}, this.state.selectedOptionValues + this.props.statusMessage.text, _jsx('div', {
      className: 'message ' + this.props.statusMessage.className
    }, void 0, this.props.statusMessage.text)) : null;

    return _react2['default'].createElement(
      'span',
      this.props,
      _jsx('span', {}, void 0, _jsx('select', {
        className: this.props.disabled ? 'disabled' : '',
        multiple: 'multiple',
        defaultValue: this.state.selectedOptionValues
      }, void 0, selectionOptions)),
      msg
    );
  }
});
module.exports = MultiSelect;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/multi-select.jsx
 ** module id = 808
 ** module chunks = 0
 **/